import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CmsService } from '../../core/services/cms.service';
import { CmsContentField } from '../../shared/models/cms';
import { CacheConstant, CMSPages, CMSTemplateNames } from '../../../app/core/constants/app.constant';
import { StaticPageContent, ContentStructureDetails } from '../../shared/models/cms';
import * as _ from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BaseComponent } from '../../../app/app.base.component';
import { AppConfigService } from '../../../app/core/services/init/app-config.service';



@Component({
    selector: 'par-major-help',
    templateUrl: './major-help.component.html',
    styleUrls: ['./major-help.component.scss']
})
export class MajorHelpComponent extends BaseComponent implements OnInit {
    envProperties = this.cache.get(CacheConstant.Env_Properties);
    isAuthenticated: boolean = false;
    cmsPageName: CMSPages;
    templateNum: any;
    buId = this.envProperties.buId;
    callToActionHelp: any[] = [];
    callToActionArrays: any;
    websiteName = this.envProperties.theme;
    cmsHelpResponse: any[];
    constructor(
        private cache: AppCacheService,
        private cmsService: CmsService,
        private authService: AuthService,
        deviceDetectorService: DeviceDetectorService,
        private appConfig: AppConfigService,
    ) {
        super(deviceDetectorService, cache, appConfig);
    }

    ngOnInit() {
        this.isAuthenticated = this.authService.isAuthenticated();
        this.getMajorHelpContent();
    }

    getMajorHelpContent() {
        if (this.isMobileDevice() && this.websiteName == 'Major') {
            this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
        }
        else
            this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
        this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
        let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.helpSeqNo : this.envProperties.cmsPageConfigVO.helpSeqNo;
        this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, pageSeqNumber).subscribe((response: any) => {
            if (!response.hasError && response.length > 0) {
                const sortedStaticContent: StaticPageContent[] = _.orderBy(
                    response,
                    [CmsContentField.ContentNum],
                    'asc'
                );
                this.callToActionArrays = sortedStaticContent;
                this.callToActionArrays.filter((dataresponse) => {
                    let homeStaticContent: StaticPageContent = dataresponse;
                    let data: ContentStructureDetails = JSON.parse(homeStaticContent.contentStructure);
                    if (dataresponse.contentName == CMSTemplateNames.Web_Help || dataresponse.contentName == CMSTemplateNames.Mobile_Help)
                        this.cmsHelpResponse = data.recordList;
                })
            }
        })
    }

    navigateToTargetLink(cmsContentLinkObj: any) {
        this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
    }
}